import React from 'react';
import { Banknote } from 'lucide-react';
import HRISListPage from '../HRISListPage';
import { getPayroll, createPayroll, updatePayroll, deletePayroll, getEmployeeList } from '../hrisApi';

const STATUS_OPTIONS = ['Draft', 'Submitted', 'Cancelled'];

const columns = [
  { key: 'employeeName', label: 'Employee' },
  { key: 'postingDate', label: 'Posting Date' },
  { key: 'payrollPeriod', label: 'Period' },
  { key: 'grossPay', label: 'Gross Pay', render: (v) => v ? `Rp ${Number(v).toLocaleString('id-ID')}` : '—' },
  { key: 'totalDeduction', label: 'Deductions', render: (v) => v ? `Rp ${Number(v).toLocaleString('id-ID')}` : '—' },
  { key: 'netPay', label: 'Net Pay', render: (v) => v ? <strong>Rp {Number(v).toLocaleString('id-ID')}</strong> : '—' },
  { key: 'status', label: 'Status', badge: true },
];

const formFields = [
  { key: 'employeeName', label: 'Employee', type: 'select', required: true, optionsLoader: getEmployeeList },
  { key: 'postingDate', label: 'Posting Date', type: 'date', required: true },
  { key: 'payrollPeriod', label: 'Payroll Period', type: 'text', required: true, placeholder: 'e.g. May 2026' },
  { key: 'startDate', label: 'Period Start', type: 'date', required: true },
  { key: 'endDate', label: 'Period End', type: 'date', required: true },
  { key: 'grossPay', label: 'Gross Pay (Rp)', type: 'number', required: true, placeholder: '0' },
  { key: 'totalDeduction', label: 'Total Deduction (Rp)', type: 'number', placeholder: '0' },
  { key: 'netPay', label: 'Net Pay (Rp)', type: 'number', placeholder: 'Auto-calculated' },
  { key: 'status', label: 'Status', type: 'select', options: STATUS_OPTIONS, defaultValue: 'Draft' },
];

const Payroll = () => (
  <HRISListPage
    title="Payroll"
    description="Process monthly payroll, generate payslips, and manage salary structures"
    icon={<Banknote />}
    columns={columns}
    fetchData={getPayroll}
    createData={createPayroll}
    updateData={updatePayroll}
    deleteData={deletePayroll}
    formFields={formFields}
    entityName="Payslip"
    searchPlaceholder="Search by employee or period..."
  />
);

export default Payroll;
